/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Social_Media_Platform_PlaceholderInputs */

const en_company_profile_social_media_platform_placeholder = /** @type {(inputs: Company_Profile_Social_Media_Platform_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. LinkedIn, Xing`)
};

const de_company_profile_social_media_platform_placeholder = /** @type {(inputs: Company_Profile_Social_Media_Platform_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. LinkedIn, Xing`)
};

/**
* | output |
* | --- |
* | "e.g. LinkedIn, Xing" |
*
* @param {Company_Profile_Social_Media_Platform_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_social_media_platform_placeholder = /** @type {((inputs?: Company_Profile_Social_Media_Platform_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Social_Media_Platform_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_social_media_platform_placeholder(inputs)
	return en_company_profile_social_media_platform_placeholder(inputs)
});